import Vue from "vue";
import App from "./App.vue";
import router from "./router.js";
import store from "./store";
import axios from "./axios";
import "./vee-validate";
import i18n from "./i18n";
import { applyDirection, storedDirection } from "./direction";
Vue.prototype.$http = axios;
import VTooltip from "v-tooltip";
import Clipboard from "v-clipboard";

Vue.use(Clipboard);
Vue.use(VTooltip);

global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;

import "./../node_modules/slick-carousel/slick/slick.css";
import "../public/css/style.scss";
import "promise-polyfill/src/polyfill";

// Restore the direction from the previous visit before the first paint;
// fetchLanguages confirms or corrects it once /languages answers.
applyDirection(storedDirection());

new Vue({
  router: router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
